module.exports = __webpack_public_path__ + "img/特殊节点.653621e8.svg";